import AncillaryNavigation from './AncillaryNavigation';

export { type AncillaryNavigationProps } from './AncillaryNavigation';
export default AncillaryNavigation;
